import React from 'react';
import { Form, Input, Select } from 'antd';
import { AddItemFormData } from './types';

const { Option } = Select;
const { TextArea } = Input;

interface WearableDetailsProps {
  styles: { [key: string]: string };
  formData: AddItemFormData;
}

const WearableDetails: React.FC<WearableDetailsProps> = ({ styles, formData }) => (
  <div className={styles.stepContainer}>
    <h2 className={styles.stepTitle}>Basic Details</h2>
    
    <div className={styles.wearableBasicsWrapper}>
      <div className={styles.wearableThumbnailPreview}>
        {formData.thumbnail && formData.thumbnail.length > 0 ? (
          <img 
            src={URL.createObjectURL(formData.thumbnail[0])} 
            alt="Product preview"
            className={styles.wearablePreviewImage}
          />
        ) : (
          <div className={styles.wearableNoImage}>
            <p>No image selected</p>
          </div>
        )}
        {formData.thumbnail && formData.thumbnail.length > 0 && (
          <p className={styles.fileName}>
            {formData.thumbnail[0]?.name}
          </p>
        )}
      </div>

      <div className={styles.wearableFormGrid}>
        <div className={styles.wearableFormColumn}>
          <Form.Item 
            label="Wearable Type" 
            name="wearableType"
            rules={[{ required: true, message: 'Please select a wearable type' }]}
            className={styles.formItem}
          >
            <Select placeholder="Select Type" className={styles.selectInput}>
              <Option value="top">Top</Option>
              <Option value="bottom">Bottom</Option>
              <Option value="accessory">Accessory</Option>
              <Option value="footwear">Footwear</Option>
              <Option value="outerwear">Outerwear</Option>
            </Select>
          </Form.Item>

          <Form.Item 
            label="Style" 
            name="style"
            rules={[{ required: true, message: 'Please select a style' }]}
            className={styles.formItem}
          >
            <Select placeholder="Select Style" className={styles.selectInput}>
              <Option value="formal">Formal</Option>
              <Option value="casual">Casual</Option>
              <Option value="sporty">Sporty</Option>
              <Option value="elegant">Elegant</Option>
              <Option value="minimalist">Minimalist</Option>
            </Select>
          </Form.Item>
        </div>

        <div className={styles.wearableFormColumn}>
          <Form.Item 
            label="Material" 
            name="material"
            rules={[{ required: true, message: 'Please select a material' }]}
            className={styles.formItem}
          >
            <Select placeholder="Select Material" className={styles.selectInput}>
              <Option value="cotton">Cotton</Option>
              <Option value="polyester">Polyester</Option>
              <Option value="wool">Wool</Option>
              <Option value="silk">Silk</Option>
              <Option value="linen">Linen</Option>
              <Option value="nylon">Nylon</Option>
            </Select>
          </Form.Item>

          <Form.Item 
            label="Fabric" 
            name="fabric"
            rules={[{ required: true, message: 'Please select a fabric' }]}
            className={styles.formItem}
          >
            <Select placeholder="Select Fabric" className={styles.selectInput}>
              <Option value="cotton">Cotton</Option>
              <Option value="blend">Cotton Blend</Option>
              <Option value="organic">Organic Cotton</Option>
              <Option value="synthetic">Synthetic</Option>
              <Option value="natural">Natural Fiber</Option>
            </Select>
          </Form.Item>
        </div>
      </div>
    </div>

    <div className={styles.wearableFullWidth}>
      <Form.Item 
        label="Item Name" 
        name="itemName"
        rules={[{ required: true, message: 'Please enter an item name' }]}
        className={styles.formItem}
      >
        <Input placeholder="Enter Item Name" className={styles.textInput} />
      </Form.Item>

      <Form.Item 
        label="Tags" 
        name="tags"
        className={styles.formItem}
      >
        <Input placeholder="Enter Tags (comma-separated)" className={styles.textInput} />
      </Form.Item>
    </div>

    <Form.Item 
      label="Description" 
      name="description"
      rules={[{ required: true, message: 'Please enter a description' }]}
      className={styles.formItem}
    >
      <TextArea 
        placeholder="Enter Description" 
        className={styles.textareaInput}
        rows={6}
      />
    </Form.Item>
  </div>
);

export default WearableDetails;
